import { render } from "./UnbindTel.vue?vue&type=template&id=6ba206ac"
import script from "./UnbindTel.vue?vue&type=script&lang=js"
export * from "./UnbindTel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__